import React from 'react';

const Overlay = ({ children, closeModal }) => {
  return (
    <div
      className="fixed inset-0 z-80 flex items-center justify-center bg-black bg-opacity-30"
      onClick={closeModal}
    >
      {children}
    </div>
  );
};

export default Overlay;
